// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"833ec77a","214":"d86a878c","216":"19140f3f","479":"ed60b333","568":"230be60c","849":"7c220603","945":"5a7ef40f"}[chunkId] + ".chunk.js";
};